import {FC, ReactNode} from "react";
import {css, cx} from "@pandacss/css";
import {Row} from "./Layout.tsx";
import {font} from "../style/typography.tsx";

interface Props {
    error?: boolean;
    children: ReactNode;
}

const hintClass = css({
    color: "neutral.350"
})

const errorClass = css({
    color: "error.500"
});


const InputHint: FC<Props> = ({error, children}) => {
    return (
        <Row>
            <span className={cx(font("description", "2", "regular"), error ? errorClass : hintClass)}>{children}</span>
        </Row>
    );
}

export default InputHint;